import { ButtonLink, Header, Stack, StackItem } from '@asgard/ui-library';
import {
  faFileSignature,
  faMessagesQuestion
} from '@fortawesome/pro-solid-svg-icons';
import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import { Hero } from './CompaniesHero.styled';

export const CompaniesHero: React.FC = () => {
  const { t } = useI18n('companies-new');

  return (
    <Hero.Root>
      <PageContentContainer containerSize="xlMax">
        <Hero.Wrapper>
          <Hero.Content>
            <Stack direction="column">
              <StackItem>
                <Header editorial as="h1" size="5xl">
                  {t('companies-new.hero.title')}
                </Header>
                <HtmlTrans
                  ns="companies-new"
                  i18nKey={'companies-new.hero.subtitle'}
                />
              </StackItem>

              <Hero.CTAs>
                <ButtonLink
                  href="#companiesForm"
                  schema="brand1"
                  variant="hard"
                  label={t('companies-new.hero.cta1')}
                  startIcon={faFileSignature}
                />

                <ButtonLink
                  href="#companiesForm"
                  schema="brand1"
                  variant="ghost"
                  label={t('companies-new.hero.cta2')}
                  startIcon={faMessagesQuestion}
                />
              </Hero.CTAs>
            </Stack>

            <StackItem>
              <img
                src={getPublicPath(
                  '/images/companies-new/companies-new-hero-image.webp'
                )}
                alt="Companies"
                width="700"
                height="528"
              />
            </StackItem>
          </Hero.Content>
        </Hero.Wrapper>
      </PageContentContainer>
    </Hero.Root>
  );
};
